// Func = limiting Scope for this file
(function(){

    //full navigation
    const fullnav = document.querySelector('.header__nav-holder');
    const primaryNav = { 
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };
 
    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
            document.querySelector('.header__logo').classList.add('white');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
            document.querySelector('.header__logo').classList.remove('white');
        });
    }
	$(document).ready(function () {

        //Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		if(!$('#attractions-filtering-form').length) {
			$('select').select2(); 
		} else {
			$('#language').select2(); 
		}

		$("#privary-navigation li").hover(function(){
            var target = $(this);
            window.mytimeout = setTimeout(function(){
                target.addClass("hover");
                $('.primary-dropdown',target).fadeIn(300);
            }, 200);
        }, function(){
            if($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $('.primary-dropdown',this).fadeOut(300);
            } else {
                clearTimeout(window.mytimeout);
            }
        });

        // fancyboxes for full screen video on media library
        $(".video-iframe").on('click', function(event) {
            event.preventDefault();
            
            $.fancybox.open({
                src: this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
                type: 'iframe',
                opts: {
                    clickOutside: 'close',
                    smallBtn: true,
                    iframe: {
                        preload: false,
                        css: {
                            width: '800px',
                            height: '338px'
                        },
                        attr: {
                            allowfullscreen: true
                        }
                    },
                    animationEffect: 'fade',
                    animationDuration: 100,
                    transitionEffect: 'fade',
                    transitionDuration: 50
                }
            });
        });

	});

	
	setTimeout(function(){
		if(document.body.classList.contains("hasAlert")) {
			document.querySelector("a.topalert__cta").removeAttribute("target");
		}
	}, 500);

    setTimeout(function(){
        if(document.getElementById('home')){
            document.getElementsByClassName('top-content-home__uvp')[0].classList.add('show-object');
        }
    }, 1000); 
	

}());
function get_ga_clientid() {
    var cookie = {};
    document.cookie.split(';').forEach(function(el) {
        var splitCookie = el.split('=');
        var key = splitCookie[0].trim();
        var value = splitCookie[1];
        cookie[key] = value;
    });
    return cookie["_ga"].substring(6);
} 